import { defineNuxtPlugin, useNuxtApp } from '#imports'
import HubspotPlugin from '@b2ag/plugin-hubspot'
import { getAppContext, getConfig } from '@b2ag/micro-front-tools'

export default defineNuxtPlugin({
  name: 'hubspot',
  enforce: 'post',
  hooks: {
    'app:mounted'() {
      const nuxtApp = useNuxtApp()
      const { appFrontType } = getAppContext()

      if (appFrontType === 'agri') {
        if (!getConfig('HUBSPOT_PORTAL_ID') || window.location.hostname.includes('localhost')) return

        nuxtApp.vueApp.use(HubspotPlugin, {
          portalId: getConfig('HUBSPOT_PORTAL_ID'),
        })
      }
    },
  },
})
